export const errorCodeMap = {
  4000: "输入错误，请检查后再试",
  4006: "用户名、邮箱或手机号已被注册",
  4007: "用户不存在",
  4002: "参数错误，请检查后再试",
  4011: "验证码错误或已过期，请重新获取",
  4012: "请先绑定手机号",
  4022: "验证码错误",
  4024: "操作过于频繁，请2分钟后再试",
  4025: "今日短信发送次数已达上限，请明日再试",
  5000: "系统繁忙，请稍后再试",
  5004: "系统繁忙，请稍后再试",
  5006: "系统繁忙，请稍后再试",
};